// src/components/SubscriptionCard.jsx
import { useState } from 'react';
import { Button as FcButton, Card as FcCard } from '../ui';

/**
 * Founder access summary shown on the profile page.
 */
export default function SubscriptionCard({ subscription, onManageBilling, onUpgrade }) {
  const [isLoading, setIsLoading] = useState(false);
  const founderDetails = [
    'Full access to all competitions and analytics',
    'No billing steps required',
    'All users are treated as founding members',
  ];

  return (
    <FcCard as="div" padding="standard" className="bg-surface-card rounded-lg shadow-sm border border-ui-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold text-content-primary">Founder Access</h2>
      </div>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-lg font-medium text-content-primary">Lifetime Access</p>
            <p className="text-sm text-content-secondary">Thanks for helping shape Footy Coach early</p>
          </div>
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-ui-success">
            Active
          </span>
        </div>

        <div className="pt-4 border-t border-ui-border space-y-3">
          {founderDetails.map((detail) => (
            <div key={detail} className="flex items-start gap-3 text-sm text-content-secondary">
              <span className="mt-1 inline-block h-2 w-2 rounded-full bg-action-primary" />
              <span>{detail}</span>
            </div>
          ))}
        </div>

        <div className="pt-4 border-t border-ui-border">
          <FcButton variant="tertiary" type="submit"
            onClick={() => window.location.assign('/dashboard')}
            className="w-full"
            style={{ backgroundColor: '#BA6830' }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#a55a2a'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#BA6830'}
          >
            Go to Dashboard
          </FcButton>
        </div>
      </div>
    </FcCard>
  );
}
